/**
 * App-wide alert messages _originally_ targeted for API/network calls (errors) _only_.
 * "Code" (for reference only) maps to "Business Exception Errors" in the spreadsheet managed by the BA.
 * RIMS' subsequent support of road test payment has forcibly mixed and matched non-API errors
 * into the global SystemAlert component, a.k.a. the orange banner. 😡
 *
 * Messages ~
 * status: 0 ~ involves network calls but API always return HTTP status 200 so frontend has to parse the response
 *    to determine the appropriate error message for display.
 * status: -1 ~ non-API (non-network call) errors that are displayed as if they are network errors.
 * status: -2 ~ unmapped error - but it should have been mapped and returned by API.
 */
export default [
  {
    code: 10,
    message: 'The reservation you selected is no longer available, please select a new reservation.',
    status: 410,
  },
  {
    code: 11,
    message: 'Reservation not found.',
    status: 404,
  },
  {
    code: 12,
    message: 'Please provide all the required information.',
    status: 400,
  },
  {
    code: 0,
    errorType: 'none',
    message: 'A confirmation text and/or e-mail has been sent to the information provided.',
    status: 200,
  },
  {
    code: 24,
    errorType: 'email',
    message: 'Your reservation is confirmed but we are experiencing technical difficulties in sending you an e-mail. ' +
      'Please re-try your e-mail confirmation request again.',
    status: 0,
  },
  {
    code: 25,
    errorType: 'sms',
    message: 'Your reservation is confirmed but we are experiencing technical difficulties in sending you a text message. ' +
      'Please re-try your text message confirmation request again.',
    status: 0,
  },
  {
    code: 26,
    errorType: 'both',
    message: 'Your reservation is confirmed but we are experiencing technical difficulties in sending you an e-mail ' +
      'and text message. Please re-try your e-mail and text message confirmation request again.',
    status: 0,
  },
  {
    code: 27,
    errorType: 'cxlRes',
    message: 'Your reservation is cancelled but we are experiencing technical difficulties in sending you a ' +
      'cancellation confirmation e-mail and / or text message. No further action is required from you at this time.',
    status: 200,
  },
  {
    code: 34,
    message: 'Your payment was not successful. Please try again.',
    status: 432,
  },
  {
    code: 35,
    message: 'Your payment was not successful. Please try again.',
    status: 432,
  },
  {
    code: 36,
    message: 'No matching RI record found for the license number that was provided.',
    status: 456,
  },
  {
    code: 37,
    message: 'RI record found with matching license number but the name or date of birth ' +
      'that was provided does not match the RI record.',
    status: 457,
  },
  {
    code: 38,
    message: 'Multiple RI records found for the license number that was provided. ' +
      'Please contact RI DMV for your requested service.',
    status: 458,
  },
  {
    code: 39,
    message: 'You are not eligible for the reservation because you do not have ' +
      'an Active or Expired Commercial Learner Permit.',
    status: 459,
  },
  {
    code: 40,
    message: 'Please schedule your reservation at least 14 days after the issue date.',
    status: 461,
  },
  {
    code: 43,
    message: 'Sorry, we only support VISA, MasterCard, Discover and American Express.',
    status: -1,
  },
  {
    code: 44,
    message: 'The card number is invalid.', // for documentation only
    status: -1,
  },
  {
    code: 45,
    message: 'The expiration month and expiration year are invalid.',   // for documentation only
    status: -1,
  },
  {
    code: -1,
    errorType: 'modRes',
    message: '{name} reservation must be modified at least 48 hours prior to the reservation time. ' +
      'There will be a charge to rebook. Please cancel {confirmation} and make a new one.',
    status: -1,
  },
  {
    code: 500,
    message: 'We are experiencing technical difficulties. Please try your request again.', 
    status: 500,
  },
  {
    code: 403,
    message: 'An unexpected technical issue has occurred. Please close this window and try again.', 
    status: 403,
  },
  {
    code: 46,
    message: 'Invalid Notice ID number entered. If you just received your Tax Notification Form, you must wait until the following business day to schedule your reservation.',
    status: 444,
  },
  {
    code: 47,
    message: 'A future appointment exists for the entered Notice ID number. You cannot have more than one appointment at a time.', 
    status: 445,
  },
];
